import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common'; // Import CommonModule
import { ReactiveFormsModule } from '@angular/forms';
import { BlockTextComponent } from '../../../common/block-text/block-text.component';
import {
  X2ExperiencesInitModel,
  X2ExperiencesInitVariables,
  X2ExperiencesModel,
  X2ExperiencesVariables,
} from '../../../../../models/email-template/x2-experiences.interface';
import { BaseComponent } from '../../../common/BaseComponent';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { PinComponent } from '../../../common/pin/pin.component';
import { Helper } from '../../../../../utils/helper';

@Component({
    selector: 'app-x2-experiences',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './x2-experiences.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './x2-experiences.component.scss'
})
export class X2ExperiencesComponent extends BaseComponent implements OnInit {
  @Input() block: X2ExperiencesModel = new X2ExperiencesInitModel();
  @Input() isPreview = false;
  @Output() blockData = new EventEmitter<any>(); // Event emitter to send data to the parent
  @Output() removeBlockEvent = new EventEmitter<string | null>(); // New EventEmitter for remove

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new X2ExperiencesInitVariables()
    }
  }

  //placeholders:
  paragraphPlaceholder: string = 'Enter Paragraph';
  image1Placeholder: string = 'First Image';
  image2Placeholder: string = 'Second Image';
  image1HrefPlaceholder: string = 'Enter First Image Redirect Link';
  image2HrefPlaceholder: string = 'Enter Second Image Redirect Link';
  image1AltPlaceholder: string = 'Enter First Image Alt Text';
  image2AltPlaceholder: string = 'Enter Second Image Alt Text';
  description1Placeholder: string = 'Enter First Description';
  description2Placeholder: string = 'Enter Second Description';
  heading1Placeholder: string = 'Enter First Heading';
  heading2Placeholder: string = 'Enter Second Heading';
  ctaLink1Placeholder: string = 'Enter First CTA Link';
  ctaText1Placeholder: string = 'Enter First CTA Text';
  ctaLink2Placeholder: string = 'Enter Second CTA Link';
  ctaText2Placeholder: string = 'Enter Second CTA Text';

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId);
  }

  onChange(value: any, fieldName: keyof X2ExperiencesVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    this.pinComponent.onContainerClick(event);
  }

  handleOnSegmentChange(segment: string, blockName: string) {
    if (this.block.variables) {
      this.block.variables[blockName as keyof X2ExperiencesVariables] = segment;
      this.blockData.emit(this.block);
    }
    return;
  }
}
